import shortid from "shortid"
import * as Objdict from "objdict"

import Stage from "@frog/source/models/Stage.js"
import Step from "@frog/source/models/Step.js"
import World from "@frog/source/models/World.js"
import Geometry from "@frog/source/utility/Geometry.js"
import Elements from "@frog/source/data/elements.js"
import Tiled from "@frog/source/utility/Tiled.js"
import Random from "@frog/source/utility/Random.js"

import ranges from "@frog/source/data/skills/parts/ranges.js"

function getFacing(direction) {
    const WEST = {"x": -1, "y": 0}
    const NORTH = {"y": -1, "x": 0}
    if(Geometry.equals(direction, WEST)
    || Geometry.equals(direction, NORTH)) {
        return "back"
    } else {
        return "front"
    }
}

const skills = {}
export default skills

skills["push"] = {
    "key": "push",
    "type": "invoke",
    "class": "support",
    "range": ranges["short"],

    "name": "Push",

    // "demonstration": {
    //     "stage": {
    //         "world": Tiled.parse({
    //             "tilemap": require("@frog/source/data/encounters/empty.tilemap.json"),
    //             "tileset": require("@frog/source/assets/images/hero-tactics/map/heroes.tileset.json"),
    //         }),
    //         "units": [
    //             {
    //                 "key": "apple",
    //                 "affiliation": "good",
    //                 "class": "captain",
    //                 "position": {"x": 0, "y": 1},
    //                 "level": 2,
    //                 "equippedSkills": {
    //                     "support1": "push element:ground flavor:shove"
    //                 }
    //             },
    //             {
    //                 "key": "banana",
    //                 "affiliation": "bad",
    //                 "class": "captain",
    //                 "position": {"x": 2, "y": 1},
    //                 "level": 1
    //             }
    //         ],
    //     },
    //     "actions": [
    //         {
    //             "type": "invoke skill",
    //             "unitKey": "apple",
    //             "skillKey": "push element:ground flavor:shove",
    //             "previousPosition": {"x": 1, "y": 1},
    //             "nextPosition": {"x": 2, "y": 1},
    //         }
    //     ]
    // },

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)
        const vector = Geometry.vector(position, performer.position)

        Step.add(step, {
            "mark": 0,
            "flourish": {
                "name": "SwingBackMovement",
                "unit": {"key": performer.key},
                "position": performer.position,
                "direction": direction,
            }
        })

        const previousPosition = position
        const nextPosition = Geometry.add(position, vector)

        Step.add(step, {
            "intent": {
                "type": "reposition",
                "positions": [previousPosition, nextPosition]
            },
        })

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        Step.add(step, {"mark": 300, "audio": {"triggerKey": "Unit:Attack"}})

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return step

        const collision = Stage.findCollision({
            stage, previousPosition, nextPosition,
            "options": {"isIgnoringLedges": true}
        })

        if(collision == undefined) {
            Step.add(step, {
                "mark": 300,
                "flourish": {
                    "name": "PushedMovement",
                    "unit": {"key": target.key},
                    "startPosition": previousPosition,
                    "endPosition": nextPosition,
                },
                "unit": {
                    "key": target.key,
                    "position": nextPosition,
                }
            })
        } else if(collision != undefined) {
            Step.add(step, {
                "mark": 300,
                "flourish": {
                    "name": "NudgedMovement",
                    "unit": {"key": target.key},
                    "position": target.position,
                    "direction": direction,
                },
            })

            const damage = 1
            Step.add(step, {
                "mark": 300,
                "unit": {
                    "key": target.key,
                    "health": target.health - damage
                },
            })

            if(collision.unit != undefined) {
                Step.add(step, {
                    "mark": 300,
                    "unit": {
                        "key": collision.unit.key,
                        "health": collision.unit.health - damage
                    },
                })
            }
        }

        return step
    }
}

skills["swap"] = {
    "key": "swap",
    "type": "invoke",
    "class": "support",
    "range": ranges["short"],
    "name": "Swap",
    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) {
            Step.add(step, [
                {
                    "mark": 0,
                    "flourish": {
                        "name": "SwingBackMovement",
                        "unit": {"key": performer.key},
                        "position": performer.position,
                        "direction": direction,
                    }
                },
                {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}}
            ])
            return step
        }

        Step.add(step, [
            {
                "mark": 0,
                "flourish": {
                    "name": "PushedMovement",
                    "unit": {"key": performer.key},
                    "startPosition": performer.position,
                    "endPosition": target.position,
                },
                "unit": {
                    "key": performer.key,
                    "position": target.position,
                }
            },
            {
                "mark": 0,
                "flourish": {
                    "name": "PushedMovement",
                    "unit": {"key": target.key},
                    "startPosition": target.position,
                    "endPosition": performer.position,
                },
                "unit": {
                    "key": target.key,
                    "position": performer.position,
                }
            },
            {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}}
        ])

        return step
    }
}

skills["far-swap"] = {
    "key": "far-swap",
    "type": "invoke",
    "class": "support",
    "name": "Far-Swap",
    "range": {
        "min": 2,
        "max": 4,
        "orthogonal": true,
        "diagonal": true,
        "type": "arc",
    },
    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const distance = Geometry.distance(performer.position, position)
        const endmark = distance * 50

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})

        Step.add(step, {
            "mark": 0,
            "endmark": endmark,
            "flourish": {
                "name": "PushedMovement",
                "unit": {"key": performer.key},
                "startPosition": performer.position,
                "endPosition": position,
            },
            "unit": {
                "key": performer.key,
                "position": position,
            }
        })

        const target = Stage.findUnitByPosition(stage, position)
        if(target != undefined) {
            Step.add(step, {
                "mark": 0,
                "endmark": endmark,
                "flourish": {
                    "name": "PushedMovement",
                    "unit": {"key": target.key},
                    "startPosition": target.position,
                    "endPosition": performer.position,
                },
                "unit": {
                    "key": target.key,
                    "position": performer.position,
                }
            })
        }

        return step
    }
}

skills["pull"] = {
    "key": "pull",
    "type": "invoke",
    "class": "support",
    "range": ranges["short"],
    "name": "Pullback",
    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)
        const oppositeDirection = Geometry.flip(direction)

        if(direction.x != 0
        && direction.y != 0) {
            console.log("Cannot calculate pull skill with non-orthogonal direction.")
            return
        }

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) {
            return step
        }

        const previousPosition = performer.position
        const nextPosition = Geometry.add(performer.position, oppositeDirection)

        const previousTargetPosition = target.position
        const nextTargetPosition = Geometry.add(target.position, oppositeDirection)

        Step.add(step, {
            "intent": {
                "type": "reposition",
                "positions": [previousPosition, nextPosition]
            },
        })
        Step.add(step, {
            "intent": {
                "type": "reposition",
                "positions": [previousTargetPosition, nextTargetPosition]
            },
        })

        const collision = Stage.findCollision({
            "stage": stage,
            previousPosition,
            nextPosition,
        })

        if(collision == undefined) {
            Step.add(step, {
                "mark": 0,
                "flourish": {
                    "name": "PushedMovement",
                    "unit": {"key": performer.key},
                    "startPosition": previousPosition,
                    "endPosition": nextPosition,
                },
                "unit": {
                    "key": performer.key,
                    "position": nextPosition,
                },
            })
            Step.add(step, {
                "mark": 0,
                "flourish": {
                    "name": "PushedMovement",
                    "unit": {"key": target.key},
                    "startPosition": previousTargetPosition,
                    "endPosition": nextTargetPosition,
                },
                "unit": {
                    "key": target.key,
                    "position": nextTargetPosition,
                }
            })
            Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        } else if(collision != undefined) {
            Step.add(step, {
                "mark": 0,
                "flourish": {
                    "name": "NudgedMovement",
                    "unit": {"key": performer.key},
                    "position": performer.position,
                    "direction": direction,
                }
            })
            Step.add(step, {
                "mark": 0,
                "flourish": {
                    "name": "NudgedMovement",
                    "unit": {"key": target.key},
                    "position": target.position,
                    "direction": direction,
                }
            })
            Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        }

        return step
    }
}

skills["teleport"] = {
    "key": "pull",
    "type": "invoke",
    "class": "support",
    "range": ranges["long"],
    "name": "Blink",
    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        if(Stage.hasCollision({stage, position})) {
            Step.add(step, [
                {
                    "mark": 0,
                    "flourish": {
                        "name": "NudgedMovement",
                        "unit": {"key": performer.key},
                        "direction": direction,
                    }
                },
                {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}}
            ])
            return step
        }

        Step.add(step, [
            {
                "mark": 0,
                "unit": {
                    "key": performer.key,
                    "position": position,
                },
            },
            {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}}
        ])

        return step
    }
}

// Used in Leviathan Dawn

skills["yoink"] = {
    "key": "yoink",

    "type": "invoke",
    "class": "support",
    "range": {
        "max": 7,
        "type": "findCollisionInDirection",
        "options": {"isIgnoringLedges": true},
    },

    "name": "GrappleHook",

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Samurai:reel"}})

        const seekray = Stage.findCollisionInDirection({
            "stage": stage,
            "position": performer.position,
            "direction": direction,
            "maxdistance": this.range.max,
            "options": {"isIgnoringLedges": true},
        })

        if(seekray.collision == undefined) {
            return step
        }

        const SPEED = 75

        if(seekray.collision.type == "world") {
            if(seekray.distance == 0) {
                Step.add(step, {
                    "mark": 0,
                    "flourish": {
                        "name": "NudgedMovement",
                        "unit": {"key": performer.key},
                        "direction": Geometry.flip(direction),
                        "position": performer.position,
                    }
                })
            } else {
                Step.add(step, {
                    "mark": 0,
                    "endmark": seekray.distance * SPEED,
                    "flourish": {
                        "name": "PushedMovement",
                        "unit": {"key": performer.key},
                        "startPosition": seekray.startPosition,
                        "endPosition": seekray.endPosition,
                    },
                    "unit": {
                        "key": performer.key,
                        "position": seekray.endPosition,
                    },
                    "intent": {
                        "type": "reposition",
                        "positions": seekray.castedPositions
                    },
                })
            }
        }

        if(seekray.collision.type == "unit") {
            Step.add(step, {
                "mark": 0,
                "flourish": {
                    "name": "NudgedMovement",
                    "unit": {"key": performer.key},
                    "direction": Geometry.flip(direction),
                    "position": performer.position,
                }
            })

            const target = seekray.collision.unit
            if(target == undefined) {
                return step
            }

            const pullray = Stage.findCollisionInDirection({
                "stage": stage,
                "position": target.position,
                "direction": Geometry.flip(direction),
                "maxdistance": this.range.max,
                "options": {"isIgnoringLedges": true},
            })

            if(pullray.distance == 0) {
                Step.add(step, {
                    "mark": 0,
                    "flourish": {
                        "name": "NudgedMovement",
                        "unit": {"key": target.key},
                        "direction": pullray.direction,
                        "position": target.position,
                    },
                })
                return step
            }

            Step.add(step, {
                "mark": 0,
                "endmark": pullray.distance * SPEED,
                "flourish": {
                    "name": "PushedMovement",
                    "unit": {"key": target.key},
                    "startPosition": pullray.startPosition,
                    "endPosition": pullray.endPosition,
                },
                "unit": {
                    "key": target.key,
                    "position": pullray.endPosition,
                },
                "intent": {
                    "type": "reposition",
                    "positions": pullray.castedPositions
                },
            })
        }

        return step
    }
}

skills["jump"] = {
    "key": "jump",

    "type": "invoke",
    "class": "support",
    "name": "Jump!!",

    "power": 1,
    "range": {
        "min": 2,
        "max": 4,
        "orthogonal": true,
        "diagonal": false,
        "arc": true,
    },
    "canTarget": function({performerKey, stage, position}) {
        const hasCollision = World.hasCollision2({
            "world": stage.world,
            position,
        })
        if(hasCollision) return false
        // const target = Stage.findUnitByPosition(stage, position)
        // if(target != undefined) return false
        return true
    },
    "calculateStep": function({performerKey, effectKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Dragoon:Jump"}})
        Step.add(step, {"mark": 0, "flourish": {"name": "SpriteFrameAnimation", "unit": {"key": performer.key, "class": performer.class}, "spriteSet": "jump/" + getFacing(direction)}})

        const innatePower = performer.power ?? 1

        const distance = Geometry.distance(performer.position, position)
        let hitmark = 300 + (distance * 100)
        Step.add(step, {"mark": hitmark, "audio": {"triggerKey": "Unit:Dragoon:Land"}})
        Step.add(step, {"mark": hitmark, "flourish": {"name": "SpriteFrameAnimation", "unit": {"key": performer.key, "class": performer.class}, "spriteSet": "spike/" + getFacing(direction)}})
        Step.add(step, {"mark": hitmark + 1000})

        Step.add(step, {
            "mark": hitmark,
            "isSkipped": true,
            "unit": {
                "key": performer.key,
                "position": position
            },
        })
        Step.add(step, {
            "mark": 0,
            "endmark": hitmark,
            "flourish": {
                "name": "jump",
                "unit": {"key": performer.key},
                "startPosition": performer.position,
                "endPosition": position,
            }
        })

        const directions = [
            {"x": -1, "y": 0},
            {"x": +1, "y": 0},
            {"x": 0, "y": -1},
            {"x": 0, "y": +1},
            // {"x": +1, "y": +1},
            // {"x": +1, "y": -1},
            // {"x": -1, "y": +1},
            // {"x": -1, "y": -1},
        ]

        directions.forEach((direction) => {
            const currentPosition = Geometry.add(position, direction)

            const target = Stage.findUnitByPosition(stage, currentPosition)
            if(target == undefined) return
            if(target.key == performer.key) return

            const nextPosition = Geometry.add(currentPosition, direction)

            const collision = Stage.findCollision({
                stage,
                "previousPosition": currentPosition,
                "nextPosition": nextPosition,
                "options": {"isIgnoringLedges": true}
            })

            if(collision != undefined) {
                Step.add(step, {
                    "mark": hitmark,
                    "flourish": {
                        "name": "NudgedMovement",
                        "unit": {"key": target.key},
                        "position": target.position,
                        "direction": direction,
                    }
                })
            } else {
                Step.add(step, {
                    "mark": hitmark,
                    "flourish": {
                        "name": "PushedMovement",
                        "unit": {"key": target.key},
                        "startPosition": currentPosition,
                        "endPosition": nextPosition,
                    },
                    "unit": {
                        "key": target.key,
                        "position": nextPosition,
                    }
                })
            }
        })

        const target = Stage.findUnitByPosition(stage, position)
        if(target != undefined) {
            const innatePower = 2
            let damage = -3 * innatePower
            if(target.health + damage > target.maxhealth) {
                damage = target.maxhealth - target.health
            }
            if(target.health + damage < 0) {
                damage = 0 - target.health
            }

            Step.add(step, {
                "mark": hitmark,
                "unit": {
                    "key": target.key,
                    "health": target.health + damage
                },
            })

            Step.add(step, {
                "mark": hitmark,
                "flourish": {"name": "NudgedMovement", "unit": {"key": target.key}, "direction": direction, "position": target.position}
            })
            Step.add(step, {"mark": hitmark, "flourish": {"name": "TextFloat", "position": target.position, "text": damage}})
        }

        return step
    }
}

skills["charge"] = {
    "key": "charge",

    "type": "invoke",
    "class": "support",
    "range": {
        "max": 7,
        "type": "findCollisionInDirection",
    },

    "name": "Charge!!",

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        const ray = Stage.findCollisionInDirection({
            "stage": stage,
            "position": performer.position,
            "direction": direction,
            "maxdistance": this.range.max,
        })

        if(ray.distance == 0) {
            Step.add(step, {
                "mark": 0,
                "flourish": {
                    "name": "NudgedMovement",
                    "unit": {"key": performer.key},
                    "position": performer.position,
                    "direction": direction,
                },
            })
        }

        Step.add(step, {
            "mark": 0,
            "flourish": {
                "name": "PushedMovement",
                "unit": {"key": performer.key},
                "startPosition": ray.startPosition,
                "endPosition": ray.endPosition,
            },
            "unit": {
                "key": performer.key,
                "position": ray.endPosition,
            },
            "intent": {
                "type": "reposition",
                "positions": ray.castedPositions
            },
        })

        return step
    }
}

skills["suplex"] = {
    "key": "suplex",
    "type": "invoke",
    "class": "support",
    "range": ranges["short"],

    "name": "Suplex",

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({"type": "invoke skill", "alphastage": stage})

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, {
            "mark": 0,
            "flourish": {
                "name": "SwingBackMovement",
                "unit": {"key": performer.key},
                "position": performer.position,
                "direction": direction,
            }
        })
        Step.add(step, {
            "mark": 0,
            "flourish": {
                "name": "Audio",
                "audio": {"triggerKey": "Unit:Attack:Utility"}
            }
        })

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return step

        const previousPosition = performer.position
        const nextPosition = Geometry.add(performer.position, Geometry.flip(direction))

        const collision = Stage.findCollision({
            stage, previousPosition, nextPosition,
            "options": {
                "isIgnoringLedges": true,
                "isIgnoringWallEdges": true,
            }
        })

        if(collision == undefined) {
            Step.add(step, {
                "mark": 300,
                "flourish": {
                    "name": "PushedMovement",
                    "unit": {"key": target.key},
                    "startPosition": target.position,
                    "endPosition": nextPosition,
                },
                "unit": {
                    "key": target.key,
                    "position": nextPosition,
                },
                "intent": {
                    "type": "reposition",
                    "positions": [target.position, performer.position, nextPosition]
                },
            })
        } else {
            Step.add(step, {
                "mark": 300,
                "flourish": {
                    "name": "NudgedMovement",
                    "unit": {"key": target.key},
                    "position": target.position,
                    "direction": direction,
                },
            })
        }

        return step
    }
}

skills["smite"] = {
    "key": "smite",
    "type": "invoke",
    "class": "support",
    "range": ranges["short"],

    "name": "Push",

    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, {
            "mark": 0,
            "flourish": {
                "name": "SwingBackMovement",
                "unit": {"key": performer.key},
                "position": performer.position,
                "direction": direction,
            }
        })

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        Step.add(step, {"mark": 300, "audio": {"triggerKey": "Unit:Attack"}})

        const intendedDistance = 2
        const ray = Stage.findCollisionInDirection({
            "stage": stage,
            "position": position,
            "direction": direction,
            "maxdistance": intendedDistance,
            "options": {"isIgnoringLedges": true}
        })

        Step.add(step, {
            "mark": 0,
            "intent": {
                "type": "reposition",
                "positions": ray.castedPositions
            }
        })

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return step

        if(ray.distance > 0) {
            Step.add(step, {
                "mark": 300,
                "flourish": {
                    "name": "PushedMovement",
                    "unit": {"key": target.key},
                    "startPosition": ray.startPosition,
                    "endPosition": ray.endPosition,
                },
                "unit": {
                    "key": target.key,
                    "position": ray.endPosition,
                },
            })
        } else {
            Step.add(step, {
                "mark": 300,
                "flourish": {
                    "name": "NudgedMovement",
                    "unit": {"key": target.key},
                    "position": target.position,
                    "direction": direction,
                },
            })
        }

        if(ray.distance < intendedDistance) {
            const damage = intendedDistance - ray.distance
            Step.add(step, {
                "mark": 300,
                "unit": {
                    "key": target.key,
                    "health": target.health - damage
                },
            })

            if(ray?.collision?.unit != undefined) {
                Step.add(step, {
                    "mark": 300,
                    "unit": {
                        "key": ray.collision.unit.key,
                        "health": ray.collision.unit.health - damage
                    },
                })
            }
        }

        return step
    }
}

skills["burst"] = {
    "key": "burst",
    "type": "invoke",
    "class": "support",
    "range": ranges["short"],
    "name": "Burst",
    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, {
            "mark": 0,
            "flourish": {
                "name": "SwingBackMovement",
                "unit": {"key": performer.key},
                "position": performer.position,
                "direction": direction,
            }
        })

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        Step.add(step, {"mark": 300, "audio": {"triggerKey": "Unit:Attack"}})



        const forces = [
            {
                "position": position,
                "direction": direction
            },
            {
                "position": Geometry.add(position, Geometry.perpendicular(direction)),
                "direction": Geometry.perpendicular(direction)
            },
            {
                "position": Geometry.add(position, Geometry.flip(Geometry.perpendicular(direction))),
                "direction": Geometry.flip(Geometry.perpendicular(direction)),
            }
        ]
        forces.forEach((force) => {
            const previousPosition = force.position
            const nextPosition = Geometry.add(force.position, force.direction)

            Step.add(step, {
                "intent": {
                    "type": "reposition",
                    // "position": force.position,
                    // "direction": force.direction,
                    "positions": [previousPosition, nextPosition]
                },
            })

            const target = Stage.findUnitByPosition(stage, force.position)
            if(target == undefined) return

            const collision = Stage.findCollision({
                stage, previousPosition, nextPosition,
                "options": {"isIgnoringLedges": true}
            })

            if(collision == undefined) {
                Step.add(step, {
                    "mark": 300,
                    "flourish": {
                        "name": "PushedMovement",
                        "unit": {"key": target.key},
                        "startPosition": previousPosition,
                        "endPosition": nextPosition,
                    },
                    "unit": {
                        "key": target.key,
                        "position": nextPosition,
                    },
                })
            } else if(collision != undefined) {
                Step.add(step, {
                    "mark": 300,
                    "flourish": {
                        "name": "NudgedMovement",
                        "unit": {"key": target.key},
                        "position": previousPosition,
                        "direction": force.direction,
                    },
                })

                const damage = 1

                Step.add(step, {
                    "mark": 300,
                    "unit": {"key": target.key, "health": target.health - damage}
                })
                if(collision.unit != undefined) {
                    Step.add(step, {
                        "mark": 300,
                        "unit": {
                            "key": collision.unit.key,
                            "health": collision.unit.health - damage
                        },
                    })
                }
            }
        })

        return step
    },
}

skills["far-burst"] = {
    "key": "far-burst",
    "type": "invoke",
    "class": "support",
    "range": {
        "min": 2,
        "max": 4,
        "orthogonal": true,
        "diagonal": false,
        "type": "arc",
    },
    "name": "Far-Burst",
    "calculateStep": function({performerKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        Step.add(step, {
            "mark": 0,
            "flourish": {
                "name": "SwingBackMovement",
                "unit": {"key": performer.key},
                "position": performer.position,
                "direction": direction,
            }
        })

        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Attack:Utility"}})
        Step.add(step, {"mark": 300, "audio": {"triggerKey": "Unit:Attack"}})

        const forces = [
            {
                "position": position,
                "direction": direction
            },
            {
                "position": Geometry.add(position, Geometry.perpendicular(direction)),
                "direction": Geometry.perpendicular(direction)
            },
            {
                "position": Geometry.add(position, Geometry.flip(Geometry.perpendicular(direction))),
                "direction": Geometry.flip(Geometry.perpendicular(direction)),
            }
        ]
        forces.forEach((force) => {
            const previousPosition = force.position
            const nextPosition = Geometry.add(force.position, force.direction)

            Step.add(step, {
                "intent": {
                    "type": "reposition",
                    "position": force.position,
                    "direction": force.direction,
                },
            })

            const collision = Stage.findCollision({
                stage, previousPosition, nextPosition,
                "options": {"isIgnoringLedges": true}
            })

            const target = Stage.findUnitByPosition(stage, force.position)
            if(target == undefined) return

            if(collision == undefined) {
                Step.add(step, {
                    "mark": 300,
                    "flourish": {
                        "name": "PushedMovement",
                        "unit": {"key": target.key},
                        "startPosition": previousPosition,
                        "endPosition": nextPosition,
                    },
                    "unit": {
                        "key": target.key,
                        "position": nextPosition,
                    },
                })
            } else if(collision != undefined) {
                Step.add(step, {
                    "mark": 300,
                    "flourish": {
                        "name": "NudgedMovement",
                        "unit": {"key": target.key},
                        "position": previousPosition,
                        "direction": force.direction,
                    },
                })

                const damage = 1
                Step.add(step, {
                    "mark": 300,
                    "unit": {"key": target.key, "health": target.health - damage}
                })
                if(collision.unit != undefined) {
                    Step.add(step, {
                        "mark": 300,
                        "unit": {
                            "key": collision.unit.key,
                            "health": collision.unit.health - damage
                        },
                    })
                }
            }
        })

        return step
    },
}

skills["explode"] = {
    "key": "explode",
    // "type": "at-my-end-of-turn",
    "type": "death-by-damage", // this isn't doing anything right now, because
    // we instead decide to run this by unit.skills["death-by-damage"]
    "calculateStep": function({stage, performerKey}) { // ignoring passed in position
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = step.omegastage.units[performerKey]
        const position = performer.position


        const EXPLOSION_POWER = 3
        const DIRECTIONS = [{"x": +1}, {"x": -1}, {"y": +1}, {"y": -1}]
        const CENTER_OFFSET = {"x": 0, "y": -0.5, "z": 0.2} // FOR TOP DOWN

        const explosions = [{
            "position": position,
            "power": EXPLOSION_POWER,
            "directions": DIRECTIONS
        }]
        const hasExploded = {}
        while(explosions.length > 0) {
            const explosion = explosions.shift()
            explosion.distance = explosion.distance || 0

            if(World.hasCollision2({
                "world": stage.world,
                "previousPosition": explosion.position,
                "nextPosition": explosion.position,
                "zone": stage.encounters[stage.currentEncounter || 1].zone,
            })) {
                continue
            }
            hasExploded[Geometry.toString(explosion.position)] = explosion

            const unit = Stage.findUnitByPosition(stage, explosion.position)
            if(unit != undefined) {
                if(unit.type == "explosive"
                && unit.key != performerKey) {
                    // explosion.power = Math.max(explosion.power, unit.power)
                    explosion.power = EXPLOSION_POWER
                    explosion.directions = DIRECTIONS.filter((direction) => Geometry.equals(direction, Geometry.flip(explosion.directions[0])) == false)
                }
                // // Do not pierce through boxes.
                // if(unit.class == "egg") { // IS SOFT BOX BLOCK
                //     explosion.power = 0
                // }
                // destroy the unit or box or bomb.
                explosion.unit = unit
            }

            if(explosion.power > 0) {
                explosion.directions.forEach((direction) => {
                    const nextPosition = Geometry.add(explosion.position, direction)
                    if(hasExploded[Geometry.toString(nextPosition)] != undefined) return
                    explosions.push({
                        "power": explosion.power - 1,
                        "distance": explosion.distance + 1,
                        "directions": [direction],
                        "position": nextPosition
                    })
                })
            }
        }

        // Step.add(step, {"mark": 0, "audio": {"triggerKey": "Explosion"}})

        Objdict.forEach(hasExploded, (explosion) => {
            Step.add(step, {
                "mark": (explosion.distance * 50) + (Math.random() * 100),
                "flourish": {
                    "type": "explode",
                    "position": explosion.position,
                    "distance": explosion.distance,
                    "performerKey": performer.key
                }
            })
            for(let i = 0; i < 10; i += 1) {
                const key = shortid.generate()
                const scale = Random.range(6, 12)

                // TODO: could I couple these as a flourish? or is this
                // the future where we leak all keyframes into the deltastages
                // (where we were already leaking them as contained flourishes
                // but now it would be the full deltastages)
                Step.add(step, {
                    "mark": (explosion.distance * 50) + (Math.random() * 100),

                    "type": "particle",
                    "key": key,
                    "scale": scale,
                    "position": Geometry.add(explosion.position, CENTER_OFFSET, {
                        "x": (Random.range(0, 0.4)) * Random.sign(),
                        "y": (Random.range(0, 0.4)) * Random.sign(),
                    }),
                })
                Step.add(step, {
                    "mark": (explosion.distance * 150) + 500,

                    "type": "particle",
                    "key": key,
                    "scale": 0,
                    "delete": true,
                })
            }


            if(explosion.unit != undefined) {
                Step.add(step, {
                    "mark": (explosion.distance * 50),
                    "unit": {
                        "key": explosion.unit.key,
                        "health": -100,
                        // "isDead": true,
                        // "opacity": 0,
                    }
                })
                // if(explosion.unit.class == "egg") {
                //     const unit = {
                //         "position": explosion.unit.position,
                //         "reference": "bomber",
                //         "key": shortid.generate(), // THIS IS DUPED WITH THE EVENTUALY UNIT.INSTANTIATE CALL, BUT WE NEED IT FOR THE DELTASTAGES SCHEMA :<
                //     }
                //     unit.mode = "create" // TODO: WE ADD THIS... TO THE DELTAUNIT?? THIS SHOULD BE OUTSIDE THE PAYLOAD.
                //     const deltastage = {"annotation": {"type": "spawn"}, "units": {[unit.key]: unit}}
                //     Step.add(step, deltastage)
                // }
            }
        })

        return step
    },
}
